<template>
  <section class="px-4 sm:px-0">
    <ul>
      <li class="content-base mb-6" v-for="(item, index) in passSectionItemPost" :key="index">
        <!-- TITLE -->
        <h1
          class="pt-4 pb-2 text-xl sm:text-2xl md:text-3xl lg:text-3xl font-semibold text-primaryPaletteLight leading-snug"
        >
          {{ item.title }}
        </h1>

        <!-- DATE & TAGS -->
        <div
          class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 text-primarydark text-xs sm:text-sm"
        >
          <div class="flex items-center gap-1">
            <CalendarSvg />
            <span>{{ renderDateFormat(item.createdAt) }}</span>
          </div>

          <div class="flex flex-wrap gap-1">
            <span
              v-for="tag in item.tags"
              :key="tag.id"
              class="px-2 py-1 text-xs sm:text-sm bg-orange-50 rounded"
            >
              {{ tag.name }}
            </span>
          </div>
        </div>

        <!-- CONTENT -->
        <p
          class="py-4 sm:py-6 prose break-words leading-6 sm:leading-7 text-sm sm:text-base text-primarydark max-w-full"
          v-html="sanitizeHtml(item.content)"
        ></p>
      </li>
    </ul>
  </section>
</template>

<script>
import reusableBase from '@/utils/reusables/dateFormat';
import CalendarSvg from '@/components/svgs/CalendarSvg.vue';
import DOMPurify from 'dompurify';
export default {
  components: { CalendarSvg },
  props: { passSectionItemPost: Object },
  setup() {
    const { renderDateFormat } = reusableBase();
    const sanitizeHtml = (html) => {
      if (!html) return '';

      // Remove &nbsp;
      html = html.replace(/&nbsp;/g, ' ');

      // Remove multiple spaces
      html = html.replace(/\s{2,}/g, ' ');

      // Remove empty paragraphs like <p><br></p>
      html = html.replace(/<p>(\s|<br\s*\/?>)*<\/p>/gi, '');

      // Trim leading & trailing spaces
      html = html.trim();

      return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
    };
    return { renderDateFormat, sanitizeHtml };
  }
};
</script>
